<template>
    <app-layout>
      <Head title="Custom Fields"/>
      <template #header>
            <div class="md:flex justify-between items-center pb-1">
                <div class="mr-4 md:mr-5 flex justify-start items-center">
                   <PageBackHeader
                        :href="route('custom-fields.index')"
                        label="Custom Fields"
                        subtitle="Edit Custom Field"
                    />
                </div>
            </div>
        </template>
  
      <div class="max-w-7xl mx-auto flex mb-6">
        <div class="w-full sm:px-6 lg:px-8">
          <div class="bg-white shadow-xl sm:rounded-lg sm:p-6 lg:p-8">
            <jet-form-section @submitted="submitHandler">
                <template #description>
                    <span class="text-base text-gray-800">
                        <span class="block mb-3 ">
                            <span class='font-bold'>Custom fields</span> help you track specific information about your contacts beyond basic details.
                        </span>
                        <span class="block text-gray-600">
                            Note: You can not update the field type for an existing custom field.
                        </span>
                    </span>
                </template>

                <template #form>
                        
                        <div class="col-span-12">
                            <label class="flex flex-col">
                                <div>
                                    Custom Field Name<span class="required">*</span>
                                </div>
                                <jet-input
                                    class="mt-1 block w-full"
                                    v-model="form.name"
                                />
                            </label>
                            <jet-input-error :message="form.errors.name" class="mt-2" />
                        </div>

                        <div class="col-span-12">
                            <label class="flex flex-col">
                                <div>Field Type <span class="required">*</span></div>
                                <multiselect
                                    disabled
                                    :options="fieldTypeOptions"
                                    v-model="fieldTypeSelected"
                                    :searchable="false"
                                    :clearable="false"
                                    label="label"
                                    placeholder="Select"
                                    select-label=""
                                    deselect-label=""
                                />
                            </label>
                            <jet-input-error :message="form.errors.field_type" class="mt-2" />
                            <label class="flex items-center cursor-pointer mt-2" v-if="fieldType == 'Number'">
                                <input
                                    type="checkbox"
                                    class="form-checkbox"
                                    v-model="form.show_decimal"
                                />
                                <span class="ml-2 text text-gray-800">
                                    Show decimal places
                                </span>
                            </label>
                        </div>


                    </template>
                    <template #actions>
                        <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                            Saved.
                        </jet-action-message>

                        <jet-button
                            :class="{ 'opacity-25': form.processing }"
                        >
                            Update
                        </jet-button>
                    </template>
                </jet-form-section>
                
          </div>
        </div>
      </div>
    </app-layout>
  </template>
  
  <script>

  export default {
    mounted() {
    },
    components: {
    },
    props: {
    },
    data() {
      return {
        fieldTypeSelected: null,
        form: this.$inertia.form(
          {
            field_type: this.$page.props.custom_field.data.type,
            name: this.$page.props.custom_field.data.name,
            show_decimal: this.$page.props.custom_field.data.show_decimal,
          },
          {
            bag: "createCustomField",
            resetOnSuccess: true
          }
        ),
      };
    },
    mounted() {
      // Initialize the fieldTypeSelected with the appropriate object from options
      this.$nextTick(() => {
        this.fieldTypeSelected = this.fieldTypeOptions.find(
          option => option.value === this.form.field_type
        );
      });
    },
    watch: {
      fieldTypeSelected(val) {
        if (val) {
          this.form.field_type = val.value;
        }
      }
    },
    computed: {
        fieldTypeOptions() {
            return this.$page.props.custom_field_types.data.map((fieldType) => {
                return {
                    label: fieldType.name,
                    value: fieldType.tra_id
                };
            });
        },
        fieldType() {
            if (!this.form.field_type) {
                return null;
            }
            return this.form.field_type;
        }
    },
    methods: {
      submitHandler() {
        this.form.post(
          route("custom-fields.update", {
            preserveScroll: true,
            customField: this.$page.props.custom_field.data.tra_id
          })
        );
      }, //ends submitHandler
    }
  };
  </script>

<style lang="scss" scoped>

.required {
    @apply text-red-500 font-bold text-xl pl-1;
}

</style>
